<script lang="ts" setup>
import { delayMs } from '@/utils/time';
const visible = ref(false);
const btnVisible = ref(false);
onMounted(async () => {
    await delayMs(200);
    btnVisible.value = true;
});
</script>
<template>
    <div class="card flex justify-center">
        <Drawer
            v-model:visible="visible"
            :header="$t('ux.labels.settings')"
            position="right"
        >
            <div class="text-xl mb-3">
                {{ $t('ux.labels.color_mode') }}
            </div>
            <Button
                class="w-full"
                :icon="isDark ? 'pi pi-moon' : 'pi pi-sun'"
                :label="isDark ? $t('ux.labels.dark') : $t('ux.labels.light')"
                severity="secondary"
                icon-pos="right"
                @click="() => (toggleDark as any)(!isDark)"
            />
        </Drawer>
        <Button
            :class="[
                'fixed! top-1/2! -right-12 transition-[right] duration-200',
                { 'right-0!': btnVisible }
            ]"
            icon="pi pi-cog"
            @click="visible = true"
        />
    </div>
</template>
